import styled from "styled-components";

export const ContainerPlanta = styled.div`
  position: absolute;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 1920px;
  height: 1080px;
  background-color: #ffffff;
  /* Bleed the white backdrop past the 1920×1080 box to fill the whole window. */
  box-shadow: 0 0 0 10000px #ffffff;
`;

// Clickable icon anchored bottom-left of the planta. Opens the planta's link
// in the in-window iframe overlay (LinkOverlay), not a new tab. Sits above the
// draggable image (high z-index, own pointer events) so a tap opens the link
// instead of dragging the floor plan.
export const PlantaLink = styled.div`
  pointer-events: auto;
  position: absolute;
  z-index: 10001;
  left: 32px;
  bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--app-accent-color, #f08a24);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  cursor: pointer;

  svg {
    width: 30px;
    height: 30px;
  }
`;

export const ContainerPlantaTitulo = styled.div`
  pointer-events: none;
  position: absolute;
  z-index: 10000;
  right: 32px;
  bottom: 24px;
  max-width: 45%;

  font-family: var(--app-font-family, "DM Sans", sans-serif);
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.3;
  text-align: right;

  color: #000000;
`;
